import * as React from "react";

import { FormControl, TFormControlProps } from "kanopi-components/Input";
import { NumberInput as Input } from "kanopi-components/NumberInput";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

type TProps = {
  step?: number;
  help: string;
} & TFormControlProps;

export const IntegerInput: React.FC<TProps> = ({
  label,
  title,
  help,
  error,
  ...props
}) => {
  return (
    <WidthContainer>
      <FormControl label={label} title={title} caption={help} error={error}>
        <Input error={error} {...props} />
      </FormControl>
    </WidthContainer>
  );
};
